@if (visible) {
  <div
    class="relative z-[25] bg-white -mt-[170px] p-4 mb-4 pt-[100px] flex justify-center gap-4 border-b border-gray-300">
    <div class="flex flex-wrap justify-center gap-3">
      <p-button
        [label]="'animalMedia.selection.toggleWebsite' | transloco"
        icon="pi pi-globe"
        severity="info"
        (click)="toggleWebsiteForSelected.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? toggleWebsiteForSelected.emit(): null"
      />
      <p-button
        (click)="toggleSharepointForSelected.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? toggleSharepointForSelected.emit(): null"
        icon="pi pi-globe"
        severity="info"
        [label]="'animalMedia.selection.toggleSharepoint' | transloco"
      />
      <p-button
        (click)="downloadSelected.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? downloadSelected.emit(): null"
        icon="pi pi-download"
        severity="info"
        [label]="'animalMedia.selection.download' | transloco"
      />
      <p-button
        (click)="deleteSelected.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? deleteSelected.emit(): null"
        icon="pi pi-trash"
        severity="danger"
        [label]="'animalMedia.selection.delete' | transloco"
      />
      <p-button
        (click)="cancelSelection.emit()"
        (keydown)="($event.key==='Enter'||$event.key===' ')? deleteSelected.emit(): null"
        icon="pi pi-times"
        styleClass="p-button-outlined border-gray-400 text-gray-600 hover:bg-gray-100 hover:border-gray-500"
        severity="secondary"
        [label]="'modal.cancel' | transloco"
      />
    </div>
  </div>
}

@if (visible) {
  <div class="fixed inset-0 bg-white/75 z-10 pointer-events-auto"></div>
}
